import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ObjectUtils } from "src/app/utils/ObjectUtils";
import { environment } from "src/environments/environment";
import { RecurrenceSubscriptionFilterDTO } from "../../schema/Billing/Filter/RecurrenceSubscriptionFilterDTO";
import { RecurrenceSubscriptionDTO } from "../../schema/Billing/RecurrenceSubscription/RecurrenceSubscriptionDTO";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";

@Injectable({
    providedIn: "root"
})
export class ApiBillingRecurrenceSubscriptionService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        this.relativePath = `${environment.billing.url}/api/v1/RecurrenceSubscription`;
    }

    public list(filters: RecurrenceSubscriptionFilterDTO): Observable<GetDataDTO<RecurrenceSubscriptionDTO>> {
        const httpParams = new HttpParams({
            fromObject: ObjectUtils.removeNullUndefinedFields(filters) as any
        });

        return this.http.get<GetDataDTO<RecurrenceSubscriptionDTO>>(`${this.relativePath}`, {
            params: httpParams
        });
    }

    public get(id: string): Observable<RecurrenceSubscriptionDTO> {
        return this.http.get<RecurrenceSubscriptionDTO>(`${this.relativePath}/${id}`);
    }

    public cancel(id: string, reason: string): Observable<RecurrenceSubscriptionDTO> {
        const httpParams = new HttpParams({
            fromObject: { reason: reason }
        });

        return this.http.delete<RecurrenceSubscriptionDTO>(`${this.relativePath}/${id}`, {
            params: httpParams
        });
    }
}
